import { SessionWithUsers } from "../../../types";
import { LuUsers as Users, LuWifi as Wifi } from "react-icons/lu";

export const ProviderSection: React.FC<SessionWithUsers> = ({ session, users }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div className="bg-gradient-to-br from-purple-50 to-violet-50 rounded-xl p-6 border border-purple-100">
      <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Users className="w-5 h-5 text-purple-600" />
        Agora Participants
      </h4>
      {session.serviceProviderMeta?.participants ? (
        <div className="space-y-2">
          {Object.entries(session.serviceProviderMeta.participants).map(([userId, agoraUser]) => (
            <div key={userId} className="flex justify-between items-center p-3 bg-white rounded-lg shadow-sm">
              <span className="text-gray-700 font-medium">{users[userId]?.name || userId}</span>
              <span className="font-mono text-sm bg-purple-100 text-purple-700 px-3 py-1 rounded-full">
                UID: {agoraUser.agoraUid}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <span className="text-gray-500">No participants data</span>
      )}
    </div>

    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
      <h4 className="font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Wifi className="w-5 h-5 text-blue-600" />
        Channel Name
      </h4>
      <div className="bg-white rounded-lg p-4 shadow-sm">
        <span className="font-mono text-gray-700 break-all">
          {session.serviceProviderMeta?.agoraChannelName || "N/A"}
        </span>
      </div>
    </div>
  </div>
);
